<script>

  import sgsUtils from './SgsUtils';

  export default {
    data() {
      return {
        meuCollapse: "true"
      }
    },
    computed: {
      _rows: function() {
        if (this.attr) {
          return this.attr.rows;
        }
        return [];
      }
    },
    props: ["attr", "moduleType", "instance", "label"],
    computed: {
      showCollapse: function() {
        let ret = true;
        if (this.moduleType === 'form' || this.moduleType === undefined) {
          if (this.attr.showInForm !== null && this.attr.showInForm !== undefined && this.attr.showInForm !== '') {
            ret = this.attr.showInForm;
          }
        } else if (this.moduleType === 'show') {
          if (this.attr.showInDetails !== null && this.attr.showInDetails !== undefined && this.attr.showInDetails !== '') {
            ret = this.attr.showInDetails;
          }
        }

        return ret;
      },
      getValue: function () {
       if (this.attr !== undefined &&  this.attr.open !== undefined) {
          return this.attr.open.toString();
        }
        return '';
      },
      hideFieldOnPrint: function () {
        if (this.attr.hideOnPrint) {
          return "noPrint";
        }
        return "";
      }
    },
    watch: {
      "instance._updated": function (newVal, oldVal) {
        if (this.instance._config[this.attr.columnName].showInForm !== undefined) {
          this.attr.showInForm = this.instance._config[this.attr.columnName].showInForm;
        }
      }
    },
    methods: {
      getIcon: function() {
        return ("glyphicon glyphicon-" + this.attr.icon);
      },
      getName: function() {
        /*if (this.attr != undefined) {
          if (this.attr.labelPt != undefined && this.attr.labelPt != "") {
            return this.attr.labelPt
          }
        }
        return "Label"*/
        return sgsUtils.getLabel({
          attr: this.attr,
          locale: this.$i18n.locale,
          label: ""
        });
      }
    }
  }

</script>

<template>
  <div v-if="showCollapse" :class="hideFieldOnPrint">

    <el-collapse class="el-collapse-01" v-model="meuCollapse">
      <el-collapse-item :name="getValue" >

        <template slot="title">
          <i v-if="attr.icon !== '' && attr.icon !== undefined" :class="getIcon()" />
          {{ getName() }}
        </template>

        <div>
          <slot></slot>
        </div>

      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<style>
  .el-collapse-01 {
    border: none !important;
    box-shadow: none !important;
  }
  .el-collapse-01 .el-collapse-item__header {
    color: rgb(255, 102, 0) !important;
    border-color: #ff6600;
    margin: 10px 0;
    padding-left: 0;
  }
  .el-collapse-01 .el-collapse-item__wrap {
    border: none;
  }
</style>



// WEBPACK FOOTER //
// SgsRenderCollapse.vue?688d443d